import { render, staticRenderFns } from "./ordersPrinting.vue?vue&type=template&id=736b3fe9"
import script from "./ordersPrinting.vue?vue&type=script&lang=js"
export * from "./ordersPrinting.vue?vue&type=script&lang=js"
import style0 from "./ordersPrinting.vue?vue&type=style&index=0&id=736b3fe9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports